import React, { useEffect, useState } from 'react'
import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai"
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper';
import slidersCards from '../../../../../json/db-pt-br.json'
import './swiper_styles.css'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import classNames from 'classnames';


export default function SwiperSlidersPtBr({handleImageClick, clickedStates , currentProject}) {
    const [windowWidth, setwindowWidth] = useState(window.innerWidth)
    const [swiperConfig, setswiperConfig] = useState({
        spaceBetween: 100,
        slidesPerView: 2 
    })
    const [startId, setStartId] = useState(0);
    const [endId, SetEndId] = useState(6);
    const [seeMore, SetSeeMore] = useState(false)
    const [tradeProjectsEffect, setTradeProjectsEffect] = useState(false)
    
    const projectsfiltered = slidersCards.filter((project) => project.id >= startId && project.id < endId);

    const HandlerProjectPreviewSeeMore = () => {
        setStartId(0);
        SetEndId(11)
    }

    const HandlerProjectPreviewSeeLess = () => {
        setStartId(0);
        SetEndId(6)
    }

    const handleSeeMoreClick = () => { 
        setTradeProjectsEffect(true);
        setTimeout(() => { 
            HandlerProjectPreviewSeeMore();
            setTradeProjectsEffect(false);
            SetSeeMore(true)
        }, 1000 )
    };

    const handleSeeLessClick = () => { 
        setTradeProjectsEffect(true);
        setTimeout(() => { 
            HandlerProjectPreviewSeeLess();
            setTradeProjectsEffect(false);
            SetSeeMore(false)
        }, 1000 )
    };
    
    useEffect (() => {
        const handlerResize = () => {
            setwindowWidth(window.innerWidth);
        }

        window.addEventListener('resize', handlerResize);

        return () => {
            window.removeEventListener('resize', handlerResize);
        };
    },[windowWidth]);

    useEffect (() => {
        const updateSwiperConfig = (width) => {
            switch(true) {

                case width <= 480:
            setswiperConfig({
                spaceBetween: 100,
                slidesPerView: 1
            });
            break;

                case width <= 600:
            setswiperConfig({
                spaceBetween: 30,
                slidesPerView: 2
            });
            break;

                case width <= 729:
            setswiperConfig({
                spaceBetween: -1,
                slidesPerView: 2
            });
            break;

                case width <= 820:
            setswiperConfig({
                spaceBetween: 50,
                slidesPerView: 2
            });
            break;

                case width <= 1024:
            setswiperConfig({
                spaceBetween: 1,
                slidesPerView: 2
            });
            break;

            default:
            setswiperConfig({
            spaceBetween: 100,
            slidesPerView: 2,
            });
        }
        
        };
        updateSwiperConfig(windowWidth)

        return () => {
            window.removeEventListener('resize', updateSwiperConfig)
        };
    }, [windowWidth]);
    
    return (
                    <Swiper
                            modules={[Navigation, Pagination, A11y,]} 
                            navigation={{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                                clickable: true ,
                            }}
                            pagination={{ 
                                el: '.swiper-pagination',
                                clickable: true ,
                                
                            }}
                            breakpoints={{
                                1400: {
                                    slidesPerView: 2,
                                    spaceBetween: -50,
                                },
                            }}
                            {...swiperConfig}
                            onSwiper={(swiper) => console.log(swiper)}
                            onSlideChange={() => console.log('slide change')}
                            >
                            
                                {projectsfiltered.map((sliders, index) =>   (
                                        <SwiperSlide key={sliders.id}>
                                            <div  className='projects_content'>
                                                <div onClick={() => handleImageClick(index, sliders)}>
                                                        <img src={sliders.image} alt='' className={`${'projects_img'}, ${currentProject ? 'handlerImgPopUpOpen' : 'projects_img'}`} />
                                                </div>
                                                <div className={`${currentProject ? 'handlerPopUpOpen' : ''}`}>
                                                    <span className='projects_subtitle'>{sliders.subtitle}</span>
                                                    <h1 className='projects_title'>{sliders.title}</h1>
                                                    
                                                    <a href={sliders.view} className='projects_button' target='_blank' rel="noreferrer">
                                                        Ver demonstração <AiOutlineArrowRight className='i' style={{color: '#2d2d2d'}}  />
                                                    </a>
                                                    <a href={sliders.github} className='projects_button' target='_blank' rel="noreferrer">
                                                        GitHub <AiOutlineArrowRight  className='i' style={{color: '#2d2d2d'}} />
                                                    </a>
                                                </div>
                                            </div>

                                        </SwiperSlide>
                                    ))}        
                                    
                                    <SwiperSlide>
                                        {!seeMore && (
                                            <div className={classNames('projects_see_more_division', { tradeProjectsEffect })} onClick={() => handleSeeMoreClick() }>
                                                <h3 className='projects_see_more'>Ver mais Projetos<AiOutlineArrowRight className={`${'i'}, ${'arrowSeeMore'}`} style={{marginLeft: '0.5em',}} /></h3>
                                            </div>
                                        )}

                                        {seeMore && (
                                            <div className={classNames('projects_see_more_division', { tradeProjectsEffect })} onClick={() => handleSeeLessClick ()}>
                                                <h3 className='projects_see_more'><AiOutlineArrowLeft className={`${'i'}, ${'arrowSeeMore'}`} style={{right: '120%',}} />Ver Menos Projetos</h3>
                                            </div>
                                        )}
                                    </SwiperSlide>

                                    
                                    
                            <div className={'swiper_controler'}>
                                <div className="swiper-button-prev"> 
                                    <IoIosArrowBack style={{color: '#4d4d4d'}} /> 
                                </div>

                                <div className="swiper-button-next"> 
                                    <IoIosArrowForward style={{color: '#4d4d4d'}} /> 
                                </div>
                            </div>

                            <div className='swiper-pagination'></div>
                            
                        </Swiper>
    )
}
